import http from './http'
import {initCurrent, updateCurrentAndReset} from "../redux/slice/currentItem";
import {useAppDispatch} from "../hooks/redux";
import {useNavigate} from "react-router-dom";
import {getSubjectId} from "../pages/biomarkers/[id]/IndicatorsAndSignals";
import _ from "underscore";
import {patchInterpretation, patchRecommendation, patchIndicator, patchSubject} from "../redux/slice/data";

export const useSmartCurrentUpdate = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const patches: any = {
    subject: patchSubject,
    recommendation: patchRecommendation,
    biomarker: patchIndicator,
    indicator: patchIndicator,
    interpretation: patchInterpretation
  }

  const smartCurrentUpdate = async (_item: any, type: string, navigate?: any) => {
    let res: any;
    let url: string = `/api/` + type;
    let isPost: boolean = !_item._id
    let item = {..._item, subjectIds: _.uniq([..._item.subjectIds || [], getSubjectId()].map(it => +it).filter(it => it))}

    res = await http.post('/api/publish', {type, item})
    // if (isPost) {
    //   res = await http.post(url, item); //{data: {...item, _id: 1}}//
    // } else {
    //   res = await http.put(url, { item });
    // }

    // let data = res.data.item;
    // let related = res.data.related;

    // console.log(res);


    // if (!data || !data._id) {
    //   console.error('Некорректный ответ от /api/publish', res.data);
    //   return;
    // }

    // Новый формат: res.data — это сам объект item
    let data = res.data;
    let related: any[] = []; // related больше не приходит

    console.log('Ответ от /api/publish:', res);

    console.log("BBM qqqqq DATAT BIOMARTKER", {type}, data, related );
    dispatch(patches[type](data))
    dispatch(updateCurrentAndReset(data));


    _.each(related, ({type, items}, ind) => {
      _.each(items, (item, ind) => {
        dispatch(patches[type](item))
      })
    })
    let hrefArr = window.location.pathname.split('/').filter(it => it);
    hrefArr[hrefArr.length - 1] = data._id;
    let newUrl = '/' + hrefArr.join('/');

    console.log("qqqqq isPOst", {isPost, data, res, related, newUrl, hrefArr} );

    function isNewSubject () {
      return hrefArr.length === 1
    }


    if (isPost) {
      // if (navigate && isNewSubject()) {
      //   navigate(newUrl)
      // } else {
      //   window.history.replaceState({}, '', newUrl);
      // }
      navigate(newUrl)

    }

    console.log("qqqqq smart connect disconnect", type, data);
    return data;
  };
  return smartCurrentUpdate;
};